var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images
    ? _c("div", { staticClass: "product-gallery" }, [
        _c("div", {
          staticClass: "feature",
          style:
            "background: url(" +
            _vm.firstImage.url +
            ") no-repeat center center / cover; \n                        flex-basis:" +
            100 / (_vm.images.length - 1) +
            "%;\n                        background-size:" +
            (!_vm.isZooming ? "cover" : "300%") +
            ";\n                        background-position:" +
            _vm.x +
            "% " +
            _vm.y +
            "%",
          on: {
            mouseover: function($event) {
              _vm.isZooming = true
            },
            mousemove: function($event) {
              return _vm.zoomOnCursor($event)
            },
            mouseleave: function($event) {
              _vm.isZooming = false
              _vm.x = 50
              _vm.y = 50
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "additional-images" },
          _vm._l(_vm.images, function(image) {
            return _c("div", {
              key: image.ID,
              staticClass: "image",
              style:
                "background: url(" +
                image.url +
                ") no-repeat center center / cover; \n                           flex-basis:calc(" +
                100 / _vm.images.length +
                "% - 2.5px);\n                           padding-bottom:" +
                100 / _vm.images.length +
                "%;\n                           ",
              attrs: { src: image.url, alt: image.alt },
              on: {
                click: function($event) {
                  return _vm.switchImage(image)
                },
                mouseover: function($event) {
                  return _vm.switchImage(image)
                }
              }
            })
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/ProductGallery.vue?vue&type=template&id=66d705b8&
// module id = 82
// module chunks = 3